import { AvailableServicesType, MiddlewareArgsType, MiddlewareType } from '../relay-types';

export const isDrawingsRelayOperation = (args: MiddlewareArgsType) => {
    const operationName = args.operation.name;
    return operationName === 'getTagFilteredListQuery' || args.operation.name.toLowerCase().includes('drawing');
};

export const graphqlRouterMiddleware =
    (availableServices: AvailableServicesType): MiddlewareType =>
    async (args, next) => {
        const { context } = args;

        if (availableServices.drawings && isDrawingsRelayOperation(args)) {
            context.url = availableServices.drawings.apiUrl;
        } else if (availableServices.schedule) {
            context.url = availableServices.schedule.apiUrl;
        }

        return next(args);
    };
